<template><div><h1 id="bankenstamm" tabindex="-1"><a class="header-anchor" href="#bankenstamm"><span>Bankenstamm</span></a></h1>
<p>Bankenstamm — Definiert Adressen und IID der Banken</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Angaben im Bankenstamm dienen der Abwicklung von automatisierten Zahlungsvorgängen (LSV, Debit Direct). Die Post und jede Filiale einer Bank in der Schweiz ist in diesem Stamm enthalten. Zusammen mit den Informationen zur Kundenkontonummer können LSV/DD-Belastungen durchgeführt werden. Die Informationen werden v.a. in der Zusage benötigt. Der Stamm an sich wird periodisch durch ARENAE aktualisiert. Es können aber auch zwischenzeitlich von Hand Eingaben gemacht werden, um Veränderungen nachführen zu können. So wird ein reibungsloser Ablauf der elektronischen Zahlungsvorgänge ermöglicht.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → LSV/DD → Bankenstamm</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<p>IID
:
<p>Instituts-Identifikation, ehemals Bankenclearingnummer, eindeutige Identifikationsnummer des Finanzinstituts
</p></p>
<p>QR-IID
:
<p>Logisches Feld zur &quot;Markierung&quot; einer QR-IID&quot;. Bei Zahlungen mit einer strukturierten QR-Referenz muss die
QR-IBAN zur Angabe des Gutschriftskontos verwendet werden. Für die QR-IID sind exklusiv Werte im Bereich
30000 –31999 reserviert.</p></p>
<p>Adresse 1,
:
Name und Anschrift des Finanzinstituts</p>
<p>Adresse 2,
:
Kommentarfeld beinhaltet Hinweise zu Nummernwechsel</p>
<p>Adresse 3,</p>
<p>:
SIC-Nummer</p>
<p>Name,
:
Der SWIFT Code der Bank</p>
<p>PLZ,
:
Das Postkonto der Bank</p>
<p>Ort
:
Telefonnummer des Finanzinstituts</p>
<dl>
<dt>Reserve 1</dt>
<dd>undefined</dd>
<dt>SIC-Nummer</dt>
<dd>undefined</dd>
<dt>SWIFT Adresse</dt>
<dd>undefined</dd>
<dt>Postkonto</dt>
<dd>undefined</dd>
<dt>Telefon</dt>
<dd>undefined</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/zusagen.html#Zusagenfakturierung" title="11.2. Zusagenfakturierung">Zusagenfakturierung</RouteLink></p>
</div></template>


